































import {Component, Watch, Prop, Vue} from 'vue-property-decorator'
import {Dictionary, ObjectCollection} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import {UFInitial} from '@/enums/UFInitial'
import Endereco from '@/model/resource/Endereco'
import * as Helper from '@/helpers'

@Component
export default class ItEnderecoFormSection extends Vue {
  @Prop({type: Object, required: true}) value!: Endereco
  @Prop({type: Object, default: null}) customErrorMessage?: Dictionary<string> | null
  @Prop({type: Boolean, default: false}) includeNumber!: boolean
  @Prop({type: Boolean, default: true}) fillFromCep?: boolean
  @Prop({type: Boolean, default: null}) autofocus!: boolean | null
  @Prop({type: Boolean}) required?: boolean
  @Prop({type: Boolean}) disabled?: boolean

  AppConfig = AppConfig

  innerAutofocus = false

  allUF = new ObjectCollection(UFInitial)
  fieldsToInput: string[] = []

  @Watch('includeNumber', {immediate: true})
  async includeNumberEvent(val: boolean) {
    if (val) {
      this.fieldsToInput = ['cep', 'logradouro', 'nro', 'bairro', 'cidade', 'uf', 'complemento' , 'pais']
    } else {
      this.fieldsToInput = ['cep', 'logradouro', 'nro', 'bairro', 'cidade', 'uf', 'complemento']
    }
  }

  @Watch('value.cep')
  async populateEnderecoFromCep() {
    if (this.fillFromCep) {
      // @ts-ignore
      await this.value.populateFromCEP(`${this._uid}populateFromCEP`)
    }
  }

  get resourceSelect() {
    return {
      uf: this.allUF.nullableItems(),
    }
  }

  setAutofocus(field: string) {
    const autofocus = this.autofocus !== null ? this.autofocus : this.innerAutofocus
    return field === 'logradouro' ? autofocus : false
  }

  tipAddress(name: string, field: string) {
    if (field === 'logradouro') {
      this.$tip.show(`${name}${field}`)
    }
  }

  async mounted() {
    // enable autofocus after the page is loaded
    await Helper.sleep(1000)
    this.innerAutofocus = true
  }
}
